module.exports = __webpack_public_path__ + "img/aboutme-me.4fa43e2a.png";